import { Profile } from '../profile'

export enum IdentityEvent {
    EMAIL_VERIFIED = 'idEmailVerified',
    IDENTITY_CHANGE = 'idChange', // fires on any identity change event (session start/stop etc.)
    IDENTITY_INIT = 'idInit', // fires immediately with locally-stored profile
    SESSION_INIT = 'idSession', // fires when an SSO session is confirmed active/inactive
    PROVIDER_ID_ASSIGNED = 'providerIdAssigned', // fires when identity provider assigns an ID for the user
    LOGIN_MODAL_READY = 'loginModalReady',
    MP_READY = 'mpReady' // fires when mParticle becomes available
}

export interface IIdentityEvent<T = Profile> extends CustomEvent<T> {
    detail: T
}
